import React from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { useExportAllSitreps } from 'components/Reports/utils/reportsExportHelpers';
import type { GetSitrepsResponse } from 'components/Reports/reports.types';

type ReportsExportButtonProps = {
  sitreps: GetSitrepsResponse[];
  filterName: string | null;
};

const ReportsExportButton: React.FC<ReportsExportButtonProps> = ({
  sitreps,
  filterName,
}) => {
  const { exportAllSitreps, isExporting } = useExportAllSitreps();

  const isDisabled = filterName === null || isExporting;

  const handleExport = async (format: 'pdf' | 'docx') => {
    await exportAllSitreps(sitreps, filterName, format);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button
            variant="outline"
            size="icon-sm"
            className="reports-view__export-trigger"
            disabled={isDisabled}
            aria-label="Export Reports"
            title="Export Reports"
          />
        }
      >
        <SharedIcon iconName="download" size="md" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => handleExport('pdf')}>
          Export as PDF
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleExport('docx')}>
          Export as Word
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ReportsExportButton;
